import * as moment from 'moment';
import { useEffect, useState } from 'react';
import { IXmTracking } from '@nkr/models/index';
import { Button, Panel } from 'react-bootstrap';
import { LabelWrapper } from '../styles';
import UploadFinalXmContents from '../../../pending-swaps/modals/upload-final-xm-contents';
import usePrevious from '@nkr/services/use-previous';
import { IValidation } from '../../../pending-swaps/modals/final-xm-validation';

interface IProps {
    item: IXmTracking,
    showUpload: boolean,
    onShowFinalXmUpload: (donorId: number, recipientId: number) => void,
    onCancelShowFinalXmUpload: () => void,
    onUploadFinalXm: (donorId: number, recipientId: number, acceptable: number, rootCause: string, correctiveAction: string, initials: string, upload: File) => void
}

const XmTrackingRow = (props: IProps) => {
    const [acceptable, setAcceptable] = useState(-1);
    const [rootCause, setRootCause] = useState('');
    const [correctiveAction, setCorrectiveAction] = useState('');
    const [initials, setInitials] = useState('');
    const [upload, setUpload] = useState<File>(null);
    const [validation, setValidation] = useState<IValidation>({
        acceptable: true,
        rootCause: true,
        correctiveAction: true,
        upload: true,
        initials: true
    });
    const [dirty, setDirty] = useState(false);

    const previousShowUpload = usePrevious(props.showUpload);

    useEffect(() => {
        if (previousShowUpload == false && props.showUpload == true) {
            setAcceptable(-1);
            setRootCause('');
            setCorrectiveAction('');
            setInitials('');
            setUpload(null);
            setValidation({
                acceptable: true,
                rootCause: true,
                correctiveAction: true,
                upload: true,
                initials: true
            });
            setDirty(false);
        }
    }, [props.showUpload])

    const handleAcceptableChange = (acceptable: number) => {
        setAcceptable(acceptable);
    };

    const handleFieldChange = (field: string, value: string) => {
        if (field == 'rootCause') {
            setRootCause(value);
        }

        if (field == 'correctiveAction') {
            setCorrectiveAction(value);
        }

        if (field == 'initials') {
            setInitials(value);
        }
    };

    const handleSelectFile = (file: File) => {
        setUpload(file);
    };

    const handleSubmit = () => {
        let newValidation: IValidation = {
            acceptable: acceptable != -1,
            rootCause: acceptable == 0 ? rootCause != '' : true,
            correctiveAction: acceptable == 0 ? correctiveAction != '' : true,
            upload: upload != null,
            initials: initials != ''
        };

        setValidation(newValidation);
        setDirty(true);

        let isValid = newValidation.acceptable && newValidation.rootCause && newValidation.correctiveAction && newValidation.upload && newValidation.initials;

        if (isValid) {
            props.onUploadFinalXm(props.item.donorId, props.item.recipientId, acceptable, rootCause, correctiveAction, initials, upload);
        }
    };

    const renderDonorCenter = (item: IXmTracking) => {
        if (item.rdnCenterId > 0) {
            return <>{item.donorCenterAlias}(<span style={{ color: 'red' }}>{item.rdnCenterAlias}</span>)</>;
        }

        return <>{item.donorCenterAlias}</>;
    };

    const getDateLabel = (item: IXmTracking) => {
        let deadline = moment(item.xmStatusDeadline);
        let d = moment.duration(deadline.diff(moment()));
        let days = d.asDays();

        if (days > 7) {
            return <LabelWrapper bsStyle='success'>{item.xmStatusDeadline}</LabelWrapper>;
        }

        if (days >= 0 && days <= 7) {
            return <LabelWrapper bsStyle='warning'>{item.xmStatusDeadline}</LabelWrapper>;
        }

        if (days < 0) {
            return <LabelWrapper bsStyle='danger'>{item.xmStatusDeadline}</LabelWrapper>;
        }
    };

    return (
        <>
            <tr>
                <td>
                    {props.item.swapNumber != '0/0/0' && props.item.id > 0 ?
                        <a href={'/center/' + props.item.recipientCenterId + '/action-center/xm-tracking/by-your-center'}>{props.item.swapNumber}</a>
                        :
                        <span>{props.item.swapNumber}</span>
                    }
                </td>
                <td>{renderDonorCenter(props.item)}</td>
                <td>{props.item.donorAlias}</td>
                <td>{props.item.recipientCenterAlias}</td>
                <td>{props.item.recipientAlias}</td>
                <td>{getDateLabel(props.item)}</td>
                <td>{props.item.xmTypeDescription}</td>
                <td>{props.item.xmStatusDescription}</td>

                {!props.item.uploadFinalXmResults ?
                    <td>{props.item.xmResultDescription}</td>
                    :
                    <td><Button bsStyle='primary' bsSize='xs' disabled={props.showUpload} onClick={() => props.onShowFinalXmUpload(props.item.donorId, props.item.recipientId)}>Upload Final XM</Button></td>
                }
            </tr>

            {props.showUpload && (
                <tr>
                    <td colSpan={9} style={{ padding: 10, textAlign: 'left' }}>
                        <Panel style={{ marginBottom: 0 }}>
                            <Panel.Body>
                                <UploadFinalXmContents
                                    acceptable={acceptable}
                                    rootCause={rootCause}
                                    correctiveAction={correctiveAction}
                                    initials={initials}
                                    upload={upload}
                                    validation={validation}
                                    dirty={dirty}
                                    isList={true}
                                    onAcceptedChange={handleAcceptableChange}
                                    onFieldChange={handleFieldChange}
                                    onUploadChange={handleSelectFile} />
                            </Panel.Body>
                            <Panel.Footer style={{ textAlign: 'right', padding: '5px 15px' }}>
                                <Button bsStyle='primary' bsSize='sm' onClick={handleSubmit}>Submit</Button>&nbsp;
                                <Button bsSize='sm' onClick={props.onCancelShowFinalXmUpload}>Cancel</Button>
                            </Panel.Footer>
                        </Panel>
                    </td>
                </tr>
            )}
        </>
    );
}

export default XmTrackingRow;